import { render, staticRenderFns } from "./MatrioshkaVisualizationColumnLabel.vue?vue&type=template&id=333bbb02&scoped=true"
import script from "./MatrioshkaVisualizationColumnLabel.vue?vue&type=script&lang=js"
export * from "./MatrioshkaVisualizationColumnLabel.vue?vue&type=script&lang=js"
import style0 from "./MatrioshkaVisualizationColumnLabel.vue?vue&type=style&index=0&id=333bbb02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333bbb02",
  null
  
)

export default component.exports